import React, { Component } from 'react';
import { connect } from 'react-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { push } from 'react-router-redux';
import Grid from '../../../../components/Grid'
import { ColumnType } from '../../../../components/Grid/constants';
import dataProvider, { Order } from '../../../../components/Grid/dataProvider';
import { isInternal } from '../../CroUtils';
import ShowOverviewHistoryButton from '../../components/audit/ShowOverviewHistoryButton';

class Ovms extends Component {
  componentWillMount() {
    this.props.breadcrumbs([{ label: 'Oprávněné orgány' }]);
  }

  onEdit = ({ id }) => {
    this.props.push(`${this.props.auth.startUrl}/opravnene-organy/form/${id}`);
  }

  onAdd = () => {
    this.props.push(`${this.props.auth.startUrl}/opravnene-organy/form`);
  }

  render() {
    const props = {
      columns: [
        {
          field: 'ic',
          label: 'IČO',
          type: ColumnType.TEXT,
          width: '10%'
        },
        {
          field: 'name',
          label: 'Název',
          type: ColumnType.TEXT,
          width: '25%'
        },
        {
          field: 'username',
          label: 'Přihlašovací jméno',
          type: ColumnType.TEXT,
          width: '10%'
        },
        {
          field: 'createNote',
          label: 'Důvod vytvoření',
          type: ColumnType.TEXT,
          width: '30%'
        },
        {
          field: 'created',
          label: 'Vytvořen',
          type: ColumnType.DATE,
          width: '5%'
        },
        {
          field: 'allOfficials',
          label: 'Náhled na všechny funkcionáře',
          type: ColumnType.YESNO,
          width: '20%',
          sortable: false,
          filterable: false
        }
      ],
      filtering: true,
      onAdd: this.onAdd,
      adding: isInternal(this.props.auth),
      editing: false,
      addButtonStyle: { color: 'white' },
      deleting: false
    };

    const ConnectedGrid = dataProvider("legitimatesGrid", { url: `${this.props.auth.startUrl}/api/opravnene-organy`, sort: 'created', order: Order.DESC }, Grid);
    return (
      <div>
        <ShowOverviewHistoryButton auth={this.props.auth} segment="opravnene-organy" />
        <ConnectedGrid onRowClick={this.onEdit} rowStyle={{ cursor: 'pointer' }} {...props} />
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, push })(Ovms);
